import React from 'react';
export function SocialProofBar() {
  return <div className="sticky top-0 z-[999] w-full h-10 bg-[#1A3320] flex items-center justify-center px-4" data-id="element-200">
      <p className="text-[#A8D5AC] text-xs md:text-sm text-center font-medium" data-id="element-201">
        ★★★★★ Más de 1,200 mujeres hispanas en USA ya recuperaron su energía •
        Satisfacción del 94%
      </p>
    </div>;
}